import { Table } from 'antd'
import { FC, PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react'
import styles from './style.module.less'

type PropType = FC<PropsWithChildren<{
  dataSource: any[]
  columns: any[]
  total?: number
  rowKey?: any
}>>

const Component: PropType = ({ dataSource, columns, total, rowKey }) => {
  const [current, setCurrent] = useState(1)
  const tableTotal = useMemo(() => {
    if(total === undefined) {
      return dataSource.length
    }
    return total
  }, [total, dataSource])

  useEffect(() => {
    setCurrent(1)
  }, [dataSource])

  return (
    <div className={styles['full-table']}>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{
          y: '100%'
        }}
        rowKey={rowKey}
        pagination={
          {
            pageSizeOptions: [10, 20, 50],
            pageSize: 10,
            showSizeChanger: true,
            total: tableTotal,
            current,
            onChange: setCurrent
          }
        }
        size="small"
      />
      <div className={styles['table-total']}>共{tableTotal}条数据</div>
    </div>
  )
}

export default Component
